/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechGetTtsHistory } from "../../funcs/llmSpeechGetTtsHistory.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetTextToSpeechHistoryRequest$inboundSchema,
};

export const tool$llmSpeechGetTtsHistory: ToolDefinition<typeof args> = {
  name: "llm-speech-get-tts-history",
  description: `Retrieve text-to-speech history item

Returns metadata for a stored text-to-speech generation.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechGetTtsHistory(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
